import { SearchTaskRequest, SearchTaskSort } from '@askporter/grieg-types';
import { LinkedTasksState, LinkedTasksActions } from '../types';

export const initialState = (filter?: SearchTaskRequest['filter']): LinkedTasksState => ({
  search: {
    freeText: '',
    sort: SearchTaskSort.RECOMMENDED,
    page: 1,
    filter: {
      created: {
        before: null,
        after: null,
      },
      due: {
        before: null,
        after: null,
      },
      assignedTeam: [],
      assignedUser: [],
      slaStatus: [],
      assignedTo: [],
      statusType: [],
      priority: [],
      status: [],
      taskType: [],
      linkedAsset: [],
      linkedOrg: [],
      linkedTeam: [],
      linkedUser: [],
      ...filter,
    },
  },
  isSearchEnabled: true,
});

const linkedTasksReducer = (state: LinkedTasksState, action: LinkedTasksActions): LinkedTasksState => {
  switch (action.type) {
    case 'SET_SEARCH_FREE_TEXT':
      return { ...state, search: { ...state.search, freeText: action.payload, page: 1 } };
    case 'SET_PAGE':
      return { ...state, search: { ...state.search, page: action.payload } };
    case 'SET_SORT':
      return { ...state, search: { ...state.search, page: 1, sort: action.payload } };
    case 'SET_FILTERS':
      return { ...state, search: { ...state.search, page: 1, filter: { ...state.search.filter, ...action.payload } } };
    case 'SET_IS_SEARCH_ENABLED':
      return { ...state, isSearchEnabled: action.payload, search: { ...state.search } };
    case 'CLEAR_ALL_FILTERS':
      return {
        ...state,
        search: {
          ...initialState().search,
          filter: { ...initialState().search.filter, ...action.payload },
        },
      };
    default:
      return state;
  }
};

export default linkedTasksReducer;
